<app-table-customer
></app-table-customer>
<p-toast></p-toast>

